import { all, call, put, takeLatest } from 'redux-saga/effects';
import { GET_COMBO_STORE } from 'actions/Store/actionTypes';
import { getComboStoreSuccess, getComboStoreFailure } from 'actions/Store';
import StoreApi from 'service/storeApi';
import { pushNotification } from 'utils/notifications';

function* getComboStore(action) {
  try {
    const response = yield call(StoreApi.combo, { storeStatus: 1 });
    if (response.ok) {
      yield put(getComboStoreSuccess(response.data));
    } else {
      pushNotification('Lỗi xảy ra', 'error', 'TOP_CENTER', 1000);
      yield put(getComboStoreFailure());
    }
  } catch (error) {
    pushNotification('Lỗi xảy ra', 'error', 'TOP_CENTER', 1000);
    yield put(getComboStoreFailure());
  }
}

function* watchGetRequest() {
  yield takeLatest(GET_COMBO_STORE, getComboStore);
}

export default function* sagas() {
  yield all([watchGetRequest()]);
}
